"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.consentGrantedSNC = exports.consentGrantedFNC = exports.consentGranted = void 0;

var _misc = require("../misc");

var consentGranted = function consentGranted(consentGroup) {
  if (!(0, _misc.noWindow)()) {
    var _window$OnetrustActiv;

    return !!((_window$OnetrustActiv = window['OnetrustActiveGroups']) === null || _window$OnetrustActiv === void 0 ? void 0 : _window$OnetrustActiv.includes(consentGroup));
  }

  return false;
};

exports.consentGranted = consentGranted;

var consentGrantedFNC = function consentGrantedFNC() {
  return consentGranted('fnc');
};

exports.consentGrantedFNC = consentGrantedFNC;

var consentGrantedSNC = function consentGrantedSNC() {
  return consentGranted('snc');
};

exports.consentGrantedSNC = consentGrantedSNC;